import React, { useEffect, useState } from 'react';

import StatCards from 'components/base/megatable/stat-cards';

import { api } from 'services/api';
import {Loader} from "../../misc/loader-utils";

import './merchant-strategy-totals.scss';

function MerchantStrategyTotals({ merchId, statType, dateRange }) {
	const [totals, setTotals] = useState({});
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		fetchTotals();
	}, [merchId, dateRange]);

	async function fetchTotals() {
		setLoading(true);

		const totalsEndpoint = `/api/v0/merchants/${merchId}/strategy/overview/tiles/`;
		const params = {
			date_from: dateRange.startDate.format('YYYY-MM-DD'),
			date_to: dateRange.endDate.format('YYYY-MM-DD'),
		};
		const resp = await api.get(totalsEndpoint, params);
		const totals = resp.data.data[0].stats[0];

		setTotals(totals);
		setLoading(false);
	}

	const tiles = !loading ? (
		<StatCards
			data={totals}
			statType={statType}
		/>
	) : null;

	return (
		<div className="merchant-strategy-totals-container">
			<Loader loading={loading} />
			{tiles}
		</div>
	);
}

export default MerchantStrategyTotals;
